const BASE_URL = '/proxy/api/lead/submitSubscribe';

export interface SubscribeLeadInput {
  firstName: string;
  lastName: string;
  email: string;
  postcode: string;
}

export interface SubscribeLeadResponse {
  success: boolean;
  // Lead key minted by the API; pushed to CDP as form.details.externalLeadId so the event joins to Salesforce.
  externalLeadId?: string;
}

export const submitSubscribeLead = (
  data: SubscribeLeadInput
): Promise<SubscribeLeadResponse> =>
  fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  }).then((res) => {
    if (!res.ok) throw new Error('Lead submission failed.');
    return res.json() as Promise<SubscribeLeadResponse>;
  });
